export interface NestToastOptions {
  title?: string;
  message?: string;
  type?: string;
  position?: string;
  duration?: number;
}
